import { FC } from 'react';

import { toast } from 'sonner';
import { BaseModal } from 'wbs-components-lib';

import { useValidateVipTaskItemMutation } from '@services';

import {
  VIP_TASK_ITEM_VALIDATE_FORM_INITIAL_VALUES,
  VipTaskItemValidateForm,
  VipTaskItemValidateFormValues,
} from '../../VipSettingsForms';

import { VipTaskItemEditModalProps } from './types';

export const VipTaskItemValidateModal: FC<VipTaskItemEditModalProps> = ({ isOpened, vipTaskItem, handleClose }) => {
  const { id: vipTaskItemId } = vipTaskItem;

  const [validateVipTaskItem, { isLoading }] = useValidateVipTaskItemMutation();

  const handleVipTaskItemValidate = async (values: VipTaskItemValidateFormValues) => {
    const { documentId } = values;

    await validateVipTaskItem({
      vipTaskItemId,
      documentId,
    }).unwrap();

    toast.success('Success: VIP task item participants has been validated!');

    handleClose();
  };

  return (
    <BaseModal
      headerTitle="Validate VIP task item"
      isOpened={isOpened}
      handleClose={handleClose}
      isFooterNeeded={false}
    >
      <VipTaskItemValidateForm
        initialValues={VIP_TASK_ITEM_VALIDATE_FORM_INITIAL_VALUES}
        isSubmitting={isLoading}
        onSubmit={handleVipTaskItemValidate}
      />
    </BaseModal>
  );
};
